<script>
	import { Col, Row } from "sveltestrap";
	import ErrorMessageHandler from "../../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import PageHeader from "../../../../components/PageHeader/PageHeader.svelte";
	import { damageReviewed, errorMessage } from "src/store/store";
	import CustomButton from "../../../../components/CustomButton/CustomButton.svelte";
	import { onMount } from "svelte";
	import client from "src/services/client";

	import ReportCard from "../../../../components/ReportCard/ReportCard.svelte";
	import ConfirmModal from "../../../../components/CustomModal/ConfirmModal.svelte";
	import { navigate } from "svelte-routing";
	import { extractErrorMessage } from "src/utils/misc";
	export let id;
	export let location;

	let err;
	let data = {};
	let lastReviewed = {};
	let hasMounted = false;
	let header = "";
	let reportText = "";
	let isOpen = false;
	let damageType = "";

	errorMessage.subscribe((value) => {
		err = value;
	});

	async function fetchReviewbyId() {
		try {
			const res = await client(`/v1/damageValidation/reviews/${id}`, {
				method: "GET",
				version: "Tasking",
			});
			data = res.data;
			lastReviewed = data.lastReviewedInfo;
			hasMounted = true;
		} catch (error) {
			console.log(error);
			extractErrorMessage(error);
		}
	}

	async function handleSubmit(damageType) {
		try {
			const res = await client(`/v1/damageValidation/reviews/${id}`, {
				method: "PUT",
				version: "Tasking",
				data: {
					result: damageType,
				},
			});
			if (res.status === 204) {
				isOpen = false;
				navigate("/issues/damage-validation?tab=2");
			}
		} catch (error) {
			console.log(error);
		}
	}

	function toggleModal(headerText, text, damage) {
		isOpen = !isOpen;
		header = headerText;
		reportText = text;
		damageType = damage;
	}

	onMount(() => {
		fetchReviewbyId();
	});
</script>

<Row class="max-height">
	<Col xs={12}>
		<div>
			<ErrorMessageHandler message={err} />
			<Col style="margin-bottom: 24px;">
				<PageHeader title={data.plateNo} />
			</Col>
			<div class="d-flex flex-row max-height report-container">
				<Col xs={6} style="padding-right: 12px;">
					<ReportCard
						data={lastReviewed}
						title={"Last Reviewed"}
						lightbox={true}
					/>
				</Col>
				<Col xs={6} style="padding-left: 12px;">
					<ReportCard {data} title={"Last Report"} lightbox={true} />
				</Col>
			</div>
			{#if !$damageReviewed}
				<div class="d-flex flex-row flex-row-reverse my-1">
					<div class="ms-1">
						<CustomButton
							buttonText="Report new damage"
							onClick={() =>
								toggleModal(
									"Report new damage?",
									"You are about to report that this vehicle has new damages. Do you wish to proceed?",
									"newDamage"
								)}
						/>
					</div>
					<div class="mx-1">
						<CustomButton
							buttonText="No new damage"
							onClick={() =>
								toggleModal(
									"Report No New Damage",
									"You are about to report ‘No New Damage’ for this vehicle. Are you sure you want to proceed?",
									"noNewDamage"
								)}
						/>
					</div>
					<div class="mx-1">
						<CustomButton
							buttonText="No damage"
							onClick={() =>
								toggleModal(
									"Report No Damage",
									"You are about to report ‘No Damage’ for this vehicle. Are you sure you want to proceed?",
									"noDamage"
								)}
						/>
					</div>
				</div>
			{:else}
				<div />
			{/if}
		</div>
	</Col>
</Row>
<ConfirmModal
	open={isOpen}
	toggle={toggleModal}
	{header}
	bodyText={reportText}
	buttonColor="primary"
	buttonText="Confirm"
	outline={false}
	handleSubmit={() => handleSubmit(damageType)}
/>

<style>
	:global(.max-height) {
		height: fit-content;
	}

	.report-container {
		margin-bottom: 24px;
	}
</style>
